import {call, put, takeLatest} from "redux-saga/effects";

import {
  createDowntime,
  createSensorDowntime,
  createMetric,
  deleteAlert,
  getAlertHistoryAsync,
  getAlertHistoryLogsAsync,
  getAlerts,
  getDowntimeGraphData,
  getSensorDowntimeGraphData,
  getDownTimeOptions,
  getMetricFieldOptions,
  getMetricGraphData,
  getMetricOptions,
  toggleAlert,
  toggleSensorAlert,
  handleAlertHandoffAsync,
  handleSensorAlertHandoffAsync,
  getSensorsListData,
  getSensorAlerts,
  deleteSensorAlert,
  getSensorAlertHistoryAsync,
  getSensorAlertHistoryLogsAsync,
} from "../AsyncActions/alerts.async";
import {
  storeAlarmHistoryLogs,
  storeDowntimeCreateData,
  storeMetricCreateData,
  storeMetricField,
  storeSensorsForAlert,
} from "../Actions/alerts.actions";

import * as actions from "../action.constants";

import {storeDataExplorerAnalysis} from "../Actions/data-explorer.actions";

function* getAlertsList(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(getAlerts, pageUrl);
    if (response) {
      yield put({type: actions.SAVE_ALERTS_LIST_DATA, payload: response?.data});
    }
  } catch (_e) {
    return _e;
  }
}

function* getSensorAlertsList(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(getSensorAlerts, pageUrl);
    if (response) {
      yield put({type: actions.SAVE_ALERTS_LIST_DATA, payload: response?.data});
    }
  } catch (_e) {
    return _e;
  }
}

function* deleteAlertRequest(action = {}) {
  const {payload, callback = () => {}} = action;
  try {
    const response = yield call(deleteAlert, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* sensorAlertDeleteGroupRequest(action = {}) {
  const {payload, callback = () => {}} = action;
  try {
    const response = yield call(deleteSensorAlert, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* getDowntimeData() {
  try {
    const response = yield call(getDownTimeOptions);
    if (response) {
      yield put(storeDowntimeCreateData(response?.data?.results[0]));
    }
  } catch (e) {
    return e;
  }
}

function* getMetricData() {
  try {
    const response = yield call(getMetricOptions);
    if (response) {
      yield put(storeMetricCreateData(response?.data?.results[0]));
    }
  } catch (e) {
    return e;
  }
}

function* getMetricFields(action = {}) {
  const {payload = {}} = action;
  try {
    const response = yield call(getMetricFieldOptions, {data: payload});
    if (response) {
      yield put(storeMetricField(response?.data?.results));
    }
  } catch (e) {
    return e;
  }
}

function* createDowntimeAlert(action = {}) {
  const {requestPayload = {}, id = "", callback = () => {}} = action;
  try {
    const response = yield call(createDowntime, {
      data: requestPayload,
      id,
    });
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* createSensorDowntimeAlert(action = {}) {
  const {requestPayload = {}, id = "", callback = () => {}} = action;
  try {
    const response = yield call(createSensorDowntime, {
      data: requestPayload,
      id,
    });
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* createMetricAlert(action = {}) {
  const {requestPayload = {}, id = "", callback = () => {}} = action;
  try {
    const response = yield call(createMetric, {
      data: requestPayload,
      id,
    });
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* toggleAlarmRequest(action = {}) {
  const {payload = {}, callback = () => {}} = action;
  try {
    const response = yield call(toggleAlert, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* toggleSensorAlarmRequest(action = {}) {
  const {payload = {}, callback = () => {}} = action;
  try {
    const response = yield call(toggleSensorAlert, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* getDowntimeGraph(action = {}) {
  const {payload} = action;
  try {
    const response = yield call(getDowntimeGraphData, payload);
    if (response?.data?.data) {
      yield put(storeDataExplorerAnalysis(response?.data?.data));
    }
  } catch (e) {
    return e;
  }
}

function* getSensorDowntimeGraph(action = {}) {
  const {payload} = action;
  try {
    const response = yield call(getSensorDowntimeGraphData, payload);
    if (response?.data?.data) {
      yield put(storeDataExplorerAnalysis(response?.data?.data));
    }
  } catch (e) {
    return e;
  }
}

function* getSensorList(action = {}) {
  const {payload} = action;
  try {
    const response = yield call(getSensorsListData, payload);
    if (response?.data?.results) {
      yield put(storeSensorsForAlert(response?.data?.results));
    }
  } catch (e) {
    return e;
  }
}

function* getMetricGraph(action = {}) {
  const {payload} = action;
  try {
    const response = yield call(getMetricGraphData, payload);
    if (response?.data?.data) {
      yield put(storeDataExplorerAnalysis(response?.data?.data));
    }
  } catch (e) {
    return e;
  }
}

function* getAlertHistory(action = {}) {
  const {payload} = action;
  try {
    const response = yield call(getAlertHistoryAsync, payload);
    if (response?.data?.data) {
      yield put(storeDataExplorerAnalysis(response?.data?.data));
    }
  } catch (e) {
    return e;
  }
}

function* getSensorAlertHistory(action = {}) {
  const {payload} = action;
  try {
    const response = yield call(getSensorAlertHistoryAsync, payload);
    if (response?.data?.data) {
      yield put(storeDataExplorerAnalysis(response?.data?.data));
    }
  } catch (e) {
    return e;
  }
}

function* getAlertHistoryLogs(action = {}) {
  const {payload} = action;
  try {
    const response = yield call(getAlertHistoryLogsAsync, payload);
    if (response?.data?.results) {
      yield put(storeAlarmHistoryLogs(response?.data?.results));
    }
  } catch (e) {
    return e;
  }
}

function* getSensorAlertHistoryLogs(action = {}) {
  const {payload} = action;
  try {
    const response = yield call(getSensorAlertHistoryLogsAsync, payload);
    if (response?.data?.results) {
      yield put(storeAlarmHistoryLogs(response?.data?.results));
    }
  } catch (e) {
    return e;
  }
}

function* handleAlertHandoff(action = {}) {
  const {payload = {}, callback = () => {}} = action;
  try {
    const response = yield call(handleAlertHandoffAsync, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* handleSensorAlertHandoff(action = {}) {
  const {payload = {}, callback = () => {}} = action;
  try {
    const response = yield call(handleSensorAlertHandoffAsync, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

export function* customersSaga() {
  yield takeLatest(actions.REQUEST_ALERTS_SAGA, getAlertsList);
  yield takeLatest(actions.REQUEST_SENSOR_ALERTS_SAGA, getSensorAlertsList);
  yield takeLatest(actions.REQUEST_DOWNTIME_CREATE_DATA, getDowntimeData);
  yield takeLatest(actions.REQUEST_METRIC_CREATE_DATA, getMetricData);
  yield takeLatest(actions.REQUEST_METRIC_FIELD, getMetricFields);
  yield takeLatest(actions.CREATE_DOWNTIME_ALERT, createDowntimeAlert);
  yield takeLatest(actions.CREATE_SENSOR_DOWNTIME_ALERT, createSensorDowntimeAlert);
  yield takeLatest(actions.CREATE_METRIC_ALERT, createMetricAlert);
  yield takeLatest(actions.DELETE_ALERT_DATA, deleteAlertRequest);
  yield takeLatest(actions.DELETE_SENSOR_ALERT_DATA, sensorAlertDeleteGroupRequest);
  yield takeLatest(actions.TOGGLE_ALARM_STATE, toggleAlarmRequest);
  yield takeLatest(actions.TOGGLE_SENSOR_ALARM_STATE, toggleSensorAlarmRequest);
  yield takeLatest(actions.REQUEST_DOWNTIME_GRAPH, getDowntimeGraph);
  yield takeLatest(actions.REQUEST_SENSOR_DOWNTIME_GRAPH, getSensorDowntimeGraph);
  yield takeLatest(actions.REQUEST_SENSOR_LIST, getSensorList);
  yield takeLatest(actions.REQUEST_METRIC_GRAPH, getMetricGraph);
  yield takeLatest(actions.REQUEST_ALARM_HISTORY, getAlertHistory);
  yield takeLatest(actions.REQUEST_ALARM_HISTORY_LOGS, getAlertHistoryLogs);
  yield takeLatest(actions.REQUEST_SENSOR_ALERT_HISTORY, getSensorAlertHistory);
  yield takeLatest(actions.REQUEST_SENSOR_ALERT_HISTORY_LOGS, getSensorAlertHistoryLogs);
  yield takeLatest(actions.ALERT_HANDOFF, handleAlertHandoff);
  yield takeLatest(actions.SENSOR_ALERT_HANDOFF, handleSensorAlertHandoff);
}
